'use client';

import { useEffect, useState } from 'react';
import {
  NO_CONSENT,
  getCookiePreferences,
  onConsentChange,
  type CookiePreferences,
} from '@/lib/cookie-consent';

/**
 * The visitor's live Cookiebot choice, for gating scripts we load ourselves
 * (PostHog, GA) rather than through a `type="text/plain"` tag.
 *
 * Always starts at NO_CONSENT so the server render and the first client render
 * agree; the real answer arrives on Cookiebot's consent event, or on mount for
 * a returning visitor whose choice Cookiebot has already restored.
 */
export function useCookieConsent(): CookiePreferences {
  const [preferences, setPreferences] = useState<CookiePreferences>(NO_CONSENT);

  useEffect(() => {
    setPreferences(getCookiePreferences());
    return onConsentChange(setPreferences);
  }, []);

  return preferences;
}
